import React from 'react';
import { TrendingUp, TrendingDown, Info } from 'lucide-react';

export default function KPICard({ 
  label, 
  value, 
  change, 
  changeType = 'neutral',
  icon,
  tooltip,
  className = '' 
}) {
  const isGradient = className.includes('bg-gradient');
  const changeColors = {
    positive: 'text-green-600 dark:text-green-400',
    negative: 'text-red-600 dark:text-red-400',
    neutral: isGradient ? 'text-white/90' : 'text-[var(--muted)]',
  };

  return (
    <div className={`
      bg-[var(--card)] border border-[var(--border)] rounded-lg p-3
      transform transition-all duration-300 hover:shadow-md hover:-translate-y-0.5
      ${className}
    `}>
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 mb-0.5 group/tooltip">
            <p className={`text-[11px] uppercase font-semibold tracking-wider truncate ${
              isGradient ? 'text-white/80' : 'text-[var(--muted)]'
            }`}>
              {label}
            </p>
            {tooltip && (
              <div className="relative shrink-0">
                <Info size={12} className="text-[var(--muted)] cursor-help" />
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 p-2.5 bg-[var(--card)] border border-[var(--border)] rounded-lg shadow-xl opacity-0 invisible group-hover/tooltip:opacity-100 group-hover/tooltip:visible transition-all duration-200 z-50 pointer-events-none">
                  <p className="text-[11px] normal-case tracking-normal text-[var(--text)] leading-relaxed whitespace-normal">{tooltip}</p>
                </div>
              </div>
            )}
          </div>
          <div className="flex items-baseline gap-2">
            <p className={`text-lg font-bold truncate ${
              isGradient ? 'text-white' : 'text-[var(--text)]'
            }`}>
              {value}
            </p>
            {change && (
              <div className={`flex items-center gap-0.5 text-[11px] font-semibold shrink-0 ${
                isGradient 
                  ? 'text-white/90' 
                  : changeColors[changeType]
              }`}>
                {changeType === 'positive' && <TrendingUp size={12} />}
                {changeType === 'negative' && <TrendingDown size={12} />}
                <span>{change}</span>
              </div>
            )}
          </div>
        </div>
        {icon && (
          <div className={`p-1.5 rounded-lg shrink-0 ml-2 ${
            isGradient 
              ? 'bg-white/20 text-white' 
              : 'bg-[var(--accent-soft)] text-[var(--accent)]'
          }`}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
